<!-- 提送货订单审核页 -->
<template>
  <div 
    class="wrapper"
    v-loading="loading">
    <span class="t1">基础信息</span>
    <div class="basecont">
      <div v-if="custom.dataType == 1">
        <div class="itemcont" v-for="tag in detailInfo.baseInfoT" :key="tag.bfield">
          <div v-if="tag.bfield==='goodsSideNameCode'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }}<span v-if="tag.val[1]">/</span>{{ tag.val[1] }}</span>
          </div>
          <div v-else-if="tag.bfield==='goodsSideUserNamePhone'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }} {{ tag.val[1] }}</span>
          </div>
          <div v-else class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="itemcont" v-for="tag in detailInfo.baseInfoS" :key="tag.bfield">
          <div v-if="tag.bfield==='goodsSideNameCode'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }}<span v-if="tag.val[1]">/</span>{{ tag.val[1] }}</span>
          </div>
          <div v-else-if="tag.bfield==='goodsSideUserNamePhone'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }} {{ tag.val[1] }}</span>
          </div>
          <div v-else class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <span class="t1 t1s">货物信息</span>
    <div class="goodsCont">
      <el-table
        :data="detailInfo.goodsList"
        style="width:100%;max-height:600px;overflow-y:auto;">
        <el-table-column
          v-for="(item,index) in goodsInfocolumn"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.prop"
          :label="item.col"
          :width="item.width"
          :fixed="item.fixed"
        >
          <template slot-scope="scope">
            <!-- 单价 -->
            <span v-if="scope.column.property==='univalent'">{{scope.row.univalent | dfFormat}}</span>
            <!-- 货物数量 -->
            <el-input-number size="mini" v-else-if="scope.column.property==='quantity'" v-model="scope.row.quantity" :precision="2" :step="1" :min="0.01" :max="99999999.99"></el-input-number>
            <!-- 货物名称/编码 -->
              <span v-else-if="scope.column.property==='goodsNameCode'">{{scope.row.goodsName}}<span v-if="scope.row.goodsName||scope.row.goodsCode">/</span>{{scope.row.goodsCode}}</span>
              <!-- 货物品类名称/编码 -->
              <span v-else-if="scope.column.property==='goodsCategoryNameCode'">{{scope.row.goodsCategoryName}}<span v-if="scope.row.goodsCategoryName||scope.row.goodsCategoryCode">/</span>{{scope.row.goodsCategoryCode}}</span>
              <!-- 货物种类名称/编码 -->
              <span v-else-if="scope.column.property==='goodsTypeNameCode'">{{scope.row.goodsTypeName}}<span v-if="scope.row.goodsTypeName||scope.row.goodsTypeCode">/</span>{{scope.row.goodsTypeCode}}</span>
            <!-- 增值服务 -->
            <span v-else-if="scope.column.property==='driverServiceStrList'">
              {{scope.row.driverServiceStrList.join('、')}}
            </span>
            <span v-else>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-divider v-if="serviceDetailArry.length>0"></el-divider>
    <span class="t1 t1s" v-if="serviceDetailArry.length>0">增值服务</span>
    <div v-if="serviceDetailArry.length>0" class="mY_defineCont">
      <div v-for="item in serviceDetailArry" :key="item.type">
        <div class="item" v-if="item.type == 1">
          <span class="left">代收货款（元）</span>
          <div class="right">
            <el-input-number size="mini" style="margin-left:24px;" v-model="item.quantity" :precision="2" :step="1" :min="0.00" :max="99999999.99"></el-input-number>
          </div>
        </div>
        <div class="item" v-else-if="item.type == 2">
          <span class="left">送货上门</span>
          <div class="right">
            <el-select size="mini" style="width:80px" v-model="item.floor" placeholder="请选择">
              <el-option
                v-for="item in floorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <span>楼&nbsp;货物数量</span>
            <el-input-number size="mini" style="margin-left:20px;" v-model="item.quantity" :precision="2" :step="1" :min="0.00" :max="99999999.99"></el-input-number>
          </div>
        </div>
        <div class="item" v-else-if="item.type == 3">
          <span class="left">货物上架</span>
          <div class="right">
            <el-input-number size="mini" style="margin-left:20px;" v-model="item.quantity" :precision="2" :step="1" :min="0.00" :max="99999999.99"></el-input-number>
          </div>
        </div>
        <div class="item" v-else-if="item.type == 4">
          <span class="left">位置腾挪</span>
          <div class="right">
            货物数量
            <el-input-number size="mini" style="margin-left:20px;" v-model="item.quantity" :precision="2" :step="1" :min="0.00" :max="99999999.99"></el-input-number>
          </div>
        </div>
        <div class="item" v-else-if="item.type == 5">
          <span class="left">退货服务（{{item.calculateUnit}}）</span>
          <div class="right">
            <el-input-number size="mini" style="margin-left:20px;" v-model="item.quantity" :precision="2" :step="1" :min="0.00" :max="99999999.99"></el-input-number>
          </div>
        </div>
        <div class="item" v-else-if="item.type == 6">
          <span class="left">装卸搬运（{{item.calculateUnit}}）</span>
          <div class="right">
            <el-input-number size="mini" style="margin-left:20px;" v-model="item.quantity" :precision="2" :step="1" :min="0.00" :max="99999999.99"></el-input-number>
          </div>
        </div>
      </div>
    </div>
    <el-divider v-if="imgSrcList.length > 0"></el-divider>
    <!-- 凭证部分 -->
    <div class="pingzhen" v-if="imgSrcList.length > 0">
      <span class="left">凭证:</span>
      <div class="imgItem" style="max-width:90%">
        <el-image
          style="width:70px;height:70px;margin-right:16px;"
          v-for="(item,index) in imgSrcList" :key="index"
          :src="item"
          :z-index=9999
          :preview-src-list="imgSrcPreList"
        >
        </el-image>
        <span v-if="imgSrcList.length>10" class="right rightred" @click="imgCloseShowMore">
          收起
          <i class="el-icon-arrow-up" style="margin-left:4px;"></i>
        </span>
        <span v-else-if="imgSrcPreList.length>10" class="right rightred" @click="imgShowMore">
          展开更多
          <i class="el-icon-arrow-down" style="margin-left:4px;"></i>
        </span>
      </div>
    </div>
    <!-- 审核 -->
    <div class="reviewCont">
      <span class="t1">审核</span>
      <div class="bzRow">
        <span class="left1">备注</span>
        <div class="left2" @click="remarkItem">确认无误</div>
      </div>
      <el-input
        type="textarea"
        style="width:400px;margin-left:44px;margin-top:12px;"
        :rows="4"
        show-word-limit
        maxlength="200"
        placeholder="请输入备注描述"
        v-model="reviewBz">
      </el-input>
      <el-button class="subBtn" type="danger" size="mini" @click="submit" :loading="reviewLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import * as columns from './common/column.js';
export default {
  data() {
    return {
      custom: null,
      loading: false,
      goodsInfocolumn: columns.goodsInfocolumnTview,
      detailInfo: {
        baseInfoT: [  //注：数组元素顺序变动会影响赋值，如需跳转需注意基础信息栏字段赋值
          {
            bfield: 'goodsOrderId',
            label: '提货单号：',
            val: ''
          },{
            bfield: 'version',
            label: '提货单版本号：',
            val: ''
          },{
            bfield: 'outerOrderId',
            label: '外部订单号：',
            val: ''
          },{
            bfield: 'customerWaybillId',
            label: '客户运单号：',
            val: ''
          },{
            bfield: 'orderId',
            label: '订单号：',
            val: ''
          },{
            bfield: 'goodsSideNameCode',
            label: '发货方/代码：',
            val: []
          },{
            bfield: 'goodsSideUserNamePhone',
            label: '发货方联系人：',
            val: []
          },{
            bfield: 'address',
            label: '发货方地址：',
            val: ''
          },{
            bfield: 'planData',
            label: '提货日期：',
            val: ''
          },{
            bfield: 'planTimeLimit',
            label: '提货时间：',
            val: ''
          }
        ],
        baseInfoS: [  //注：数组元素顺序变动会影响赋值，如需跳转需注意基础信息栏字段赋值
          {
            bfield: 'goodsOrderId',
            label: '送货单号：',
            val: ''
          },{
            bfield: 'version',
            label: '送货单版本号：',
            val: ''
          },{
            bfield: 'outerOrderId',
            label: '外部订单号：',
            val: ''
          },{
            bfield: 'customerWaybillId',
            label: '客户运单号：',
            val: ''
          },{
            bfield: 'orderId',
            label: '订单号：',
            val: ''
          },{
            bfield: 'goodsSideNameCode',
            label: '发货方/代码：',
            val: []
          },{
            bfield: 'goodsSideUserNamePhone',
            label: '发货方联系人：',
            val: []
          },{
            bfield: 'address',
            label: '发货方地址：',
            val: ''
          },{
            bfield: 'planData',
            label: '送货日期：',
            val: ''
          },{
            bfield: 'planTimeLimit',
            label: '送货时间：',
            val: ''
          }
        ],
        goodsList: []
      },
      floorOptions: [
        {
          value: '-5',
          label: '-5'
        },{
          value: '-4',
          label: '-4'
        },{
          value: '-3',
          label: '-3'
        },{
          value: '-2',
          label: '-2'
        },{
          value: '-1',
          label: '-1'
        },{
          value: '2',
          label: '2'
        },{
          value: '3',
          label: '3'
        },{
          value: '4',
          label: '4'
        },{
          value: '5',
          label: '5'
        },{
          value: '6',
          label: '6'
        },{
          value: '7',
          label: '7'
        },{
          value: '8',
          label: '8'
        },{
          value: '9',
          label: '9'
        },{
          value: '10',
          label: '10'
        },{
          value: '11',
          label: '11'
        },{
          value: '12',
          label: '12'
        },{
          value: '13',
          label: '13'
        },{
          value: '14',
          label: '14'
        },{
          value: '15',
          label: '15'
        }
      ],
      serviceDetailArry: [],
      imgSrcList: [],
      imgListMoreArry: [],
      imgSrcPreList: [],
      reviewBz: '',
      remarkList: [],
      reviewLoading: false,
      initalDetailInfo: null, //用来保存页面初始化进来接口返回的数据对象
      BACKGROUND: ''
    };
  },
  created() {
    this.custom = JSON.parse(sessionStorage.getItem('manifestReviewParama'));
    this.BACKGROUND = this.getHostUrl();
  },
  mounted() {
    this.getDetail();
  },
  filters: {
    dfFormat: function(val) {
      if(val) {
        let y = String(val).indexOf(".") + 1;//获取小数点的位置
        let count = String(val).length - y;//获取小数点后的个数
        if(y > 0 && count > 2) {
          return String(val).substring(0,String(val).indexOf(".")+3)
        }else{
          return val;
        }
      } else {
        return val;
      }
    }
  },
  methods: {
    ...mapActions([
      'manifestDetailApi',
      'manifestDetaiReviewlApi'
    ]),
    getHostUrl() {
      return location.protocol + "//" + location.host;
    },
    // 获取详情信息
    getDetail() {
      this.loading = true;
      this.manifestDetailApi(this.custom).then((response) => {
          this.loading = false;
          this.initalDetailInfo = response
          if(this.custom.dataType == 1) {
            this.detailInfo.baseInfoT[0].val = response.goodsOrderId;
            this.detailInfo.baseInfoT[1].val = response.version;
            this.detailInfo.baseInfoT[2].val = response.outerOrderId;
            this.detailInfo.baseInfoT[3].val = response.customerWaybillId;
            this.detailInfo.baseInfoT[4].val = response.orderId;
            this.detailInfo.baseInfoT[5].val[0] = response.goodsSideName;
            this.detailInfo.baseInfoT[5].val[1] = response.goodsSideCode;
            this.detailInfo.baseInfoT[6].val[0] = response.contactName;
            this.detailInfo.baseInfoT[6].val[1] = response.contactPhone;
            this.detailInfo.baseInfoT[7].val = response.address;
            this.detailInfo.baseInfoT[8].val = response.planData;
            this.detailInfo.baseInfoT[9].val = response.planTimeLimit;
          } else {
            this.detailInfo.baseInfoS[0].val = response.goodsOrderId;
            this.detailInfo.baseInfoS[1].val = response.version;
            this.detailInfo.baseInfoS[2].val = response.outerOrderId;
            this.detailInfo.baseInfoS[3].val = response.customerWaybillId;
            this.detailInfo.baseInfoS[4].val = response.orderId;
            this.detailInfo.baseInfoS[5].val[0] = response.goodsSideName;
            this.detailInfo.baseInfoS[5].val[1] = response.goodsSideCode;
            this.detailInfo.baseInfoS[6].val[0] = response.contactName;
            this.detailInfo.baseInfoS[6].val[1] = response.contactPhone;
            this.detailInfo.baseInfoS[7].val = response.address;
            this.detailInfo.baseInfoS[8].val = response.planData;
            this.detailInfo.baseInfoS[9].val = response.planTimeLimit;
          }
          this.detailInfo.goodsList = response.goodsList;
          this.serviceDetailArry = response.goodsList[0].appreciationServiceDtoList || [];
          if(this.serviceDetailArry.length > 0) {
            this.imgSrcPreList = this.serviceDetailArry[0].picList || [];
          }else{
            this.imgSrcPreList = [];
          }
          // 拼接图片url
          if(this.imgSrcPreList.length > 0) {
            for(let i=0,l=this.imgSrcPreList.length; i<l; i++) {
              if(!this.imgSrcPreList[i].includes(this.BACKGROUND)){
                this.imgSrcPreList[i] = `${this.BACKGROUND}/saas/companyQualification/viewImage?objectName=${this.imgSrcPreList[i]}`
              }
            }
          }
          if(this.imgSrcPreList.length > 10) {
            this.imgSrcList = this.imgSrcPreList.slice(0,10);
            this.imgListMoreArry = this.imgSrcPreList.slice(10);
          }else{
            this.imgSrcList = this.imgSrcPreList;
            this.imgListMoreArry = [];
          }
        },
          (response) => {
            this.initalDetailInfo = null;
            this.loading = false;
          }
      );
    },
    // 弹框图片点击展开更多
    imgShowMore() {
      this.imgSrcList = [...this.imgSrcList, ...this.imgListMoreArry]
    },
    // 弹框图片点击收起
    imgCloseShowMore() {
      this.imgSrcList = this.imgSrcPreList.slice(0,10);
      this.imgListMoreArry = this.imgSrcPreList.slice(10);
    },
    // 审核备注点击确认无误
    remarkItem() {
      let markitem = '确认无误';
      if (this.remarkList.includes(markitem)) {
        for (let i = 0; i < this.remarkList.length; i++) {
          if (this.remarkList[i] === markitem) {
            this.remarkList.splice(i, 1);
            break;
          }
        }
      } else {
        this.remarkList.push(markitem);
      }
      this.reviewBz = this.remarkList.join(',');
    },
    // 审核提交
    submit() {
      this.reviewLoading = true;
      let parama = {
        outerOrderId: this.initalDetailInfo.outerOrderId,
        comment: this.reviewBz,
        dataType: this.custom.dataType,
        goodsOrderId: this.initalDetailInfo.goodsOrderId,	
        address: this.initalDetailInfo.address,
        coordinate: this.initalDetailInfo.coordinate,
        totalWeight: this.initalDetailInfo.totalWeight,
        driverOperateType: this.initalDetailInfo.driverOperateType,
        deliveryUniqueId: this.initalDetailInfo.deliveryUniqueId,
        driverService: this.detailInfo.goodsList[0].driverService,
        driverServiceStrList: this.detailInfo.goodsList[0].driverServiceStrList,
        appreciationServiceDtoList: this.serviceDetailArry,
        contactName: this.initalDetailInfo.contactName,
        contactPhone: this.initalDetailInfo.contactPhone,
        goodsSideName: this.initalDetailInfo.goodsSideName,
        goodsDtos: this.detailInfo.goodsList
      };
      this.manifestDetaiReviewlApi(parama).then((response) => {
        this.reviewLoading = false;
        this.$message({
          message: '审核成功',
          type: 'success'
        });
        this.$router.push('/manage/orderManifestList');
      },
        (response) => {
          this.reviewLoading = false;
        }
      );
    }
  }
};
</script>
<style lang="less" scoped>
.mY_defineCont{
  width: 500px;
  padding: 22px !important;
  padding-bottom: 28px !important;
  .item{
    margin-bottom: 24px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    color: #333333;
    .left{
      font-size: 16px;
      font-weight: 500;
    }
    .right{
      font-size: 14px;
      .rr{
        margin-left: 4px !important;
      }
    }
    .rightred{
      color:#DC1E32;
      cursor: pointer;
    }
  }
  .itemNobot{
    margin-bottom: 0;
  }
  .imgItem{
    margin-top: -30px !important;
    img{
      display: inline-block;
      width: 70px;
    }
  }
  .divider{
    margin: 24px 0 !important;
    border-bottom: 1px solid rgba(234,234,234,1);
  }
}
.wrapper {
  padding: 24px 32px !important;
  padding-bottom: 288px !important;
  box-sizing: border-box !important;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
  /deep/ .cell {
    padding-right: 8px !important;
    box-sizing: border-box;
  }
  .t1{
    font-size: 16px;
    color: #000000;
    display: inline-block;
  }
  .t1s{
    margin-top: 20px !important;
  }
  .basecont,
  .goodsCont{
    overflow: hidden;
    margin-top: 18px !important;
    margin-bottom: 30px !important;
    .itemcont{
      .item{
        float: left;
        width: 25%;
        padding: 8px 0 !important;
        padding-right: 8px !important;
        box-sizing: border-box;
        display: flex;
        align-items: top;
        line-height: 19px;
        .left{
          font-size: 14px;
          color: #888888;
        }
        .right{
          flex: 1;
          font-size: 14px;
          color: #000000;
        }
      }
    }
  }
  .el-divider--horizontal{
    margin: 24px 0 !important;
  }
  .pingzhen{
    display: flex;
    .left{
      width: 40px;
      font-size: 14px;
      color: rgba(0,0,0,0.65);
      font-weight: 400;
    }
    .rightred{
      font-size: 14px;
      color: #DC1E32;
      font-weight: 400;
      cursor: pointer;
    }
  }
  .reviewCont{
    box-shadow: 0px -6px 20px 0px rgba(0,0,0,0.15);
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    height: 256px;
    padding: 24px 32px !important;
    box-sizing: border-box !important;
    .bzRow{
      width: 100%;
      margin-top: 16px !important;
      overflow: hidden;
      .left1{
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        font-weight: 400;
        margin-right: 16px !important;
        float: left;
      }
      .left2{
        float: left;
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 90px;
        height: 22px;
        font-size: 12px;
        color: #000000;
        font-weight: 400;
        display: inline-block;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        background: #F5F5F5;
        cursor: pointer;
      }
    }
    .subBtn{
      width: 74px;
      margin-top: 24px !important;
      margin-left: 44px !important;
      font-size: 14px;
      color: #FFFFFF;
      font-weight: 500;
      background: #DC1E32;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>